import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Footer from '../../components/layout/Footer';
import logo from '../../assets/images/logo.jpg';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: '#F8FCFB' }}>
      <header className="w-full border-b bg-white/90 backdrop-blur-sm sticky top-0 z-10" style={{ borderColor: '#E5EFF3' }}>
        <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 py-3 sm:px-6">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm font-semibold transition-colors"
            style={{ color: '#0B2530' }}
          >
            <img src={logo} alt="HelpDesk" className="h-9 w-9 rounded-xl object-contain" />
            <span className="hidden sm:inline">HelpDesk Platform</span>
          </Link>
          <Link
            to="/signin"
            className="inline-flex items-center gap-1.5 rounded-xl px-3 py-2 text-sm font-semibold transition-colors"
            style={{ color: '#006600', backgroundColor: '#E0F8F3' }}
          >
            <ArrowLeft className="h-4 w-4" />
            Back to Sign In
          </Link>
        </div>
      </header>

      <main className="flex-1 w-full">
        <div className="mx-auto max-w-6xl px-4 py-6 sm:px-6 sm:py-8">
          <div
            className="rounded-2xl border bg-white px-6 py-6 sm:px-8 sm:py-7"
            style={{ borderColor: '#E5EFF3' }}
          >
            <h1 className="text-2xl font-bold sm:text-3xl" style={{ color: '#0B2530' }}>
              Privacy Policy
            </h1>
            {/* <p className="mt-1 text-sm" style={{ color: '#4A5B63' }}>
              Helpdesk Management System
            </p> */}
            {/* <p className="mt-0.5 text-sm" style={{ color: '#4A5B63' }}>
              Last Updated: July 2026
            </p> */}

            <div className="mt-5 space-y-4 text-sm leading-relaxed" style={{ color: '#4A5B63' }}>
              <section>
                <h2 className="mb-1 font-bold" style={{ color: '#0B2530' }}>
                  1. About the Application
                </h2>
                <p>
                  The Helpdesk Management System is a secure platform designed to help organizations manage customer support requests, track tickets, and improve service delivery. The system is used by customers, support agents, supervisors, and administrators.
                </p>
              </section>

              <section>
                <h2 className="mb-1 font-bold" style={{ color: '#0B2530' }}>
                  2. Information We Collect
                </h2>
                <ul className="list-disc space-y-0.5 pl-5">
                  <li>Name</li>
                  <li>Email Address</li>
                  <li>Phone Number (if provided)</li>
                  <li>User Role &amp; Organization</li>
                  <li>Ticket Details and Attachments</li>
                </ul>
              </section>

              <section>
                <h2 className="mb-1 font-bold" style={{ color: '#0B2530' }}>
                  3. How We Use Information
                </h2>
                <ul className="list-disc space-y-0.5 pl-5">
                  <li>User authentication</li>
                  <li>Ticket management</li>
                  <li>Notifications</li>
                  <li>Service improvements</li>
                  <li>Reporting</li>
                </ul>
              </section>

              <section>
                <h2 className="mb-1 font-bold" style={{ color: '#0B2530' }}>
                  4. Information Sharing
                </h2>
                <p>
                  Your information is shared only with authorized users within your organization and trusted services required to operate the Helpdesk platform. We do not sell your personal information.
                </p>
              </section>

              <section>
                <h2 className="mb-1 font-bold" style={{ color: '#0B2530' }}>
                  5. Data Security
                </h2>
                <p>
                  We protect your information using secure authentication, role-based access control, encrypted communication where applicable, and other security measures designed to safeguard your data.
                </p>
              </section>

              <section>
                <h2 className="mb-1 font-bold" style={{ color: '#0B2530' }}>
                  6. Contact Us
                </h2>
                <p>
                  For any privacy-related questions or requests, please contact your organization&apos;s Helpdesk Administrator or the support team responsible for your Helpdesk deployment.
                </p>
              </section>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
